import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarClock } from "lucide-react";
import { api } from "@/lib/api";
import { fmtDate } from "@/lib/finance";

const PATH = { loan: "/prestamos/", investment: "/inversiones/" };

export const InvestmentAlerts = () => {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/alerts/inversiones").then((r) => setItems(r.data.items)).catch(() => setItems([])); }, []);
  return (
    <div data-testid="investment-alerts" className="rounded-xl p-3 space-y-1.5 bg-amber-500/10 border border-amber-500/30">
      <p className="text-[11px] font-semibold uppercase tracking-wider text-amber-800 dark:text-amber-200 flex items-center gap-1.5"><CalendarClock className="w-3.5 h-3.5" /> Vencimientos próximos</p>
      {items === null && <p className="text-sm c-muted">Cargando…</p>}
      {items?.length === 0 && <p data-testid="investment-alerts-empty" className="text-sm c-muted">Sin vencimientos en los próximos 30 días.</p>}
      {items?.map((a) => (
        <Link key={a.id} to={`${PATH[a.entity_type]}${a.entity_id}`} data-testid="investment-alert-item" className="block text-sm hover:underline">
          {a.title}{a.due_date ? <span className="c-muted"> · {fmtDate(a.due_date)}</span> : null}
        </Link>
      ))}
    </div>
  );
};
